<template>
    <div class="register-finish-page">
        <div class="finish-page-content">
            <site-img
                class="finish-page-img"
                :src="finishPageImg"
                alt="Success"
                dir="height"
                style="height: 60px"
            />
            <slot name="title">
                <div
                    class="finish-page-title"
                    v-if="finishedTitle"
                    v-html="finishedTitle"
                ></div>
                <div
                    class="finish-page-subTitle"
                    v-if="finishedSubTitle"
                    v-html="finishedSubTitle"
                ></div>
            </slot>
        </div>
        <site-button
            v-if="finishBtnText"
            type="normal"
            :html="finishBtnText"
            class="finish-page-button"
            @click="handleClick"
        />
    </div>
</template>

<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
export default {
    i18next: {
        ns: 'common'
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        subTitle: {
            type: String,
            default: ''
        },
        btnText: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {
            finishPageImg:
                'https://cdn.chime.me/image/fs/sitebuild/2024823/6/original_caf6cc31-59b9-4a95-9806-ab39425ab833.png'
        };
    },
    computed: {
        ...mapState(usePageStore, {
            defaultCompanyName: store => store.defaultCompanyName
        }),
        finishedTitle() {
            return this.title || this.$t('finishPage.title');
        },
        finishedSubTitle() {
            return (
                this.subTitle ||
                this.$t('finishPage.subTitle2', {
                    companyName: this.defaultCompanyName
                })
            );
        },
        finishBtnText() {
            return this.btnText || this.$t('finishPage.btnText');
        }
    },
    methods: {
        handleClick() {
            this.$emit('handleClick');
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/theme/mixin.scss';
.register-finish-page {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    .finish-page-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .finish-page-img {
            flex-shrink: 0;
            margin-bottom: 30px;
        }
        .finish-page-title {
            font-size: 20px;
            font-weight: 700;
            line-height: 30px;
            text-align: center;
            color: var(--g-primary-color);
            font-family: 'font-Montserrat-700';
        }
        .finish-page-subTitle {
            margin-top: 15px;
            font-size: 12px;
            line-height: 1.5;
            text-align: center;
            color: var(--g-text-color);
        }
    }
    .finish-page-button {
        width: 100%;
        margin: 30px 0;
    }
    .site-button {
        height: 40px;
        padding: 10px 20px;
        font-size: 16px;
        border-radius: 5px;
    }
}
</style>